import Button from '@atlaskit/button';
import Modal, {
    ModalBody,
    ModalHeader,
    ModalTitle,
    ModalFooter,
    ModalTransition,
} from '@atlaskit/modal-dialog';
import { Box } from '@atlaskit/primitives';

interface CloudSiteReplacementModalProps {
    isOpen: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

export const CloudSiteReplacementModal = ({ isOpen, onConfirm, onCancel }: CloudSiteReplacementModalProps) => {
    return (
        <ModalTransition>
            {isOpen && (
                <Modal onClose={onCancel}>
                    <ModalHeader>
                        <ModalTitle>Update cloud site</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <Box>
                            <p>Your old cloud site details will be removed and new one will be created. Do you wish to continue?</p>
                        </Box>
                    </ModalBody>
                    <ModalFooter>
                        <Box style={{
                            display: 'flex',
                            gap: '12px',
                            justifyContent: 'flex-end'
                        }}>
                            <Button appearance="subtle" onClick={onCancel}>
                                Cancel
                            </Button>
                            <Button appearance="warning" onClick={onConfirm}>
                                Continue
                            </Button>
                        </Box>
                    </ModalFooter>
                </Modal>
            )}
        </ModalTransition>
    );
}; 